export default __webpack_public_path__ + "static/media/QrCode.ce871a8f.svg";